import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env/environment'

@Injectable({ providedIn: 'root' })
export class MarkClientChatAsReadCommand {
  constructor(private httpClient: HttpClient) {}

  call(organizationId: number, lastReadMessageId: number): Observable<void> {
    const url = `${environment.api.app}/help_desk/client/organizations/${organizationId}/chat/mark_as_read`
    return this.httpClient.post<void>(url, { last_read_message_id: lastReadMessageId })
  }
}
